export enum EBillStatus {
  OPEN = 'OPEN_TICKET',
  CLOSED = 'CLOSED',
  VOIDED = 'VOIDED',
  REFUNDED = 'REFUNDED',
  MERGED = 'MERGED',
  DELETED = 'DELETED',
}
export type BillStatus = `${EBillStatus}`;

export enum EPaymentType {
  CASH = 'CASH',
  CREDIT_CARD = 'CREDIT_CARD',
  CHECK = 'CHECK',
  GIFT_CARD = 'GIFT_CARD',
  LOYALTY_POINT = 'LOYALTY_POINT',
  PAYPAL = 'PAYPAL',
  VENMO = 'VENMO',
  CASH_APPS = 'CASH_APPS',
  ZELLE = 'ZELLE',
  EBT_FOOD = 'EBT_FOOD',
  EBT_CASH = 'EBT_CASH',
}
export type PaymentType = keyof typeof EPaymentType;

export interface TicketSummary {
  subTotal: number;
  discount: number;
  tip: number | null;
  total: number;
  feeCreditCard: number;
  tax: number;
}

export interface NewTicket {
  billId: string;
  discount: number;
  tax: number;
  total: number;
  subTotal: number;
  createdDate: string;
  ticketNumber: number;
}

export interface TicketItem {
  detailId: string;
  itemId: string;
  itemName: string;
  itemType: string;
  price: number;
  discount: number;
  quantity: number;
}

export interface TicketPayment {
  paymentId: string;
  amount: number;
  feeCredit: number | null;
  last4: string | null;
  transactionNumber: string | null;
  paymentType: PaymentType;
  authCode: string | null;
  stationNumber: string;
  cardType: string | null;
  entryType: string | null;
  invoiceNumber: string | null;
  cardNameHolder: string;
  signature: string | null;
}

export interface Ticket {
  billId: string;
  customerName: string;
  customerPhone: string;
  staffId: string | null;
  staffName: string;
  avatar: string | null;
  ticketNumber: number;
  createdDated: string;
  total: number;
  subTotal: number;
  discount: number;
  cardFee: number;
  tax: number;
  enableVoid: boolean;
  enableRefund: boolean;
  items: TicketItem[];
  payments: TicketPayment[];
}

export interface TicketSearchParams {
  status?: BillStatus;
  ticketNumber?: number;
  last4Num?: number;
  paymentType?: PaymentType;
  startDate: string;
  endDate: string;
  page?: number;
  size?: number;
}

export type GetTicketListParams = TicketSearchParams;

export type GetTicketSummaryParams = TicketSearchParams;

export interface TicketDetail {
  billId: string;
  customerId: string | null;
  staffId: string | null;
  staffName: string;
  avatar: string;
  ticketNumber: number;
  createdDated: string;
  customerName: string;
  customerPhone: string;
  customerPoint: number;
  status: BillStatus;
  total: number;
  subTotal: number;
  cardFee: number;
  discount: number;
  discountItem: number;
  saleTax: number;
  useTax: number;
  tax: number;
  signature: string | null;
  items: TicketItem[];
  payments: TicketPayment[];
}

export interface UpdateTicketItem {
  itemId: string;
  itemName: string;
  itemType: string;
  price: number;
  discount: number;
  quantity: number;
}

export interface UpdateTicketRequest {
  billId: string;
  customerId?: string;
  staffId?: string;
  couponId?: string;
  subTotal: number;
  tax: number;
  total: number;
  discount: number;
  chargeFee: boolean;
  cashIncentiveDiscount: boolean;
  items: UpdateTicketItem[];
}

export interface RefundTicketRequest {
  billId: string;
  amount: number;
  note: string;
}

export type VoidTicketRequest = Omit<RefundTicketRequest, 'amount'>;

export enum EEmailSMSType {
  EMAIl = 'EMAIL',
  SMS = 'SMS',
}
export type EmailSMSRequest = {
  billId: string;
  type: `${EEmailSMSType}`;
  value: string;
};
